import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  success: css``,
  warning: css``,
  error: css``,
};

export const help = css`
  font-size: 14px;
  display: block;
  font-weight: 400;
  line-height: 20px;

  &.${variants.success} {
    color: ${theme.colors.success['95']};
  }

  &.${variants.warning} {
    color: ${theme.colors.warning['80']};
  }

  &.${variants.error} {
    color: ${theme.colors.error['95']};
  }

  color: ${theme.colors.peoople['gris-medio']};
`;
